import { Table, TableProps } from 'antd';
import { ReactElement, useEffect, useMemo, useRef, useState } from 'react';
// import { useTranslation } from 'react-i18next';
import './index.scss';

interface OrderTableProps extends TableProps<any> {
  autoScrollY?: boolean;
}

const ZeissTable = (props: OrderTableProps): ReactElement => {
  // const { t } = useTranslation();
  const { className, scroll, autoScrollY = true, ...rest } = props;
  const [tableHeight, setTableHeight] = useState<number>(0);
  const [needYScroll, setNeedYScroll] = useState(true);
  const wrapRef = useRef<HTMLDivElement>(null);

  if (rest.pagination) {
    rest.pagination = {
      showQuickJumper: false,
      showSizeChanger: true,
      showLessItems: true,
      showTotal: (total) => `共 ${total} 条数据`,
      size: 'default',
      position: ['bottomCenter'],
      className: 'zeiss-reset-pagination',
      ...rest.pagination
    };
  }

  const rowClassName = (row: any, index: number) => {
    if (index % 2 == 0) {
      return 'pc-table-normal-line';
    } else {
      return 'pc-table-selected-line';
    }
  };

  useEffect(() => {
    const padding = 22;
    const pageHeight = 16;
    const tableEle = wrapRef.current?.querySelector('.zeiss-table-tbody');
    const tableTop = (tableEle?.getBoundingClientRect().top || 0) as number;
    setTableHeight(tableTop + pageHeight + padding);
  }, [props.dataSource]);

  const innerY = useMemo(() => {
    const dynamicY = window.innerHeight - tableHeight;
    return Math.max(120, Math.min(420, dynamicY));
  }, [tableHeight]);

  useEffect(() => {
    const calcNeedYScroll = () => {
      const tableTbody = wrapRef.current?.querySelector(
        '.zeiss-table-tbody, .ant-table-tbody'
      ) as HTMLElement | null;

      if (!tableTbody) {
        return;
      }

      const contentHeight = tableTbody.getBoundingClientRect().height;
      setNeedYScroll(contentHeight > innerY + 1);
    };

    calcNeedYScroll();

    const timer = window.setTimeout(calcNeedYScroll, 0);
    window.addEventListener('resize', calcNeedYScroll);

    return () => {
      window.clearTimeout(timer);
      window.removeEventListener('resize', calcNeedYScroll);
    };
  }, [props.dataSource, innerY]);

  const mergedScroll = {
    ...scroll
    // y: scroll?.y ?? (autoScrollY && needYScroll ? innerY : undefined)
  };

  return (
    <div ref={wrapRef}>
      <Table
        rowClassName={rowClassName}
        {...rest}
        className={[
          'zeiss-reset-table',
          !rest.dataSource?.length ? 'no-data' : '',
          className
        ].join(' ')}
        scroll={mergedScroll}
      />
    </div>
  );
};

export default ZeissTable;
